import axios from 'axios';
import {
    IMPACT_SCORE_WIDGET_DATA_KEY,
    IMPACT_SCORE_WIDGET_CHART_DATA_KEY,
    IMPACT_SCORE_WIDGET_PREVIOUS_DATA_KEY
} from '@/assets/dashboard/cache-keys';
import toSnakeCase from '@/helpers/toSnakeCase';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';


export const state = () => ({});

export const getters = {
    DATA_KEY: () => IMPACT_SCORE_WIDGET_DATA_KEY,
    CHART_DATA_KEY: () => IMPACT_SCORE_WIDGET_CHART_DATA_KEY,
    PREVIOUS_DATA_KEY: () => IMPACT_SCORE_WIDGET_PREVIOUS_DATA_KEY
};

export const mutations = {};

export const actions = {
    getScore(vuexContext, { range, accountId, properties }) {
        const params = {
            range,
            accountId,
            properties: toSnakeCase(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/impact_score', {
            params
        });
    },

    getReputation(vuexContext, { range, accountId, timeZone, properties, interval }) {
        const params = {
            range,
            timeZone,
            interval,
            accountId,
            properties: [toSnakeCase(properties)]
        };

        return axios.getMethodOverridePost('/v1/dashboard/reputation', {
            params,
            encodeURI: true
        });
    },

    getSharesCount(vuexContext, { range, accountId, properties }) {
        const params = {
            range,
            accountId,
            properties: toSnakeCase(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/shares_count', {
            params,
            encodeURI: true
        });
    },

    getReachScore(vuexContext, { range, accountId, properties }) {
        const params = {
            range,
            accountId,
            properties: toSnakeCase(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/reach_score', {
            params,
            encodeURI: true
        });
    },

    csv(vuexContext, { range, accountId, timeZone, properties, interval, searchName }) {
        const params = {
            range,
            timeZone,
            interval,
            accountId,
            properties: toSnakeCaseThenStringify(properties),
            searchName
        };

        return axios.getMethodOverridePostWithHeaders('/v1/dashboard/reports/general.csv', {
            params,
            encodeURI: true
        });
    }
};
